// Your settings › Voice (VOICE-CHOICES): `/c/{slug}/setup/voice`. A person's own voice and mood,
// plus the company default for managers; every member opens it (c.$slug.setup.tsx lets this page
// past the managers' gate).
import { createRoute } from "@tanstack/react-router";
import { VoiceSettingsScreen } from "../features/settings/voice-settings";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupVoiceRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "voice",
  component: function SetupVoicePage() {
    const { api } = setupVoiceRoute.useRouteContext();
    return <VoiceSettingsScreen api={api} company={useCompany()} />;
  },
});
